import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { OMS_BOOKABLE_CHECK_ENABLED } from '@scripts/woo_services.module/shared-types';
import { SystemService } from '@scripts/woo_services.module/SystemService';

@Injectable({ providedIn: 'root' })
class OmsBookingToggleRedirect {
  private systemService = inject(SystemService);
  private router = inject(Router);

  async toOmsWhenEnabled(state: RouterStateSnapshot): Promise<boolean> {
    const enabled = await this.systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED);
    return enabled ? this.redirect(state.url.replace('/campaigns/', '/campaigns/oms/')) : true;
  }

  async toLegacyWhenDisabled(state: RouterStateSnapshot): Promise<boolean> {
    const enabled = await this.systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED);
    return enabled || this.redirect(state.url.replace('/campaigns/oms/', '/campaigns/'));
  }

  private redirect(url: string): boolean {
    const state = this.router.getCurrentNavigation()?.extras.state;
    void this.router.navigateByUrl(url, { state, replaceUrl: true });
    return false;
  }
}

export const RedirectToOmsBookingGuard: CanActivateFn = (_route, state) =>
  inject(OmsBookingToggleRedirect).toOmsWhenEnabled(state);

export const RedirectToLegacyBookingGuard: CanActivateFn = (_route, state) =>
  inject(OmsBookingToggleRedirect).toLegacyWhenDisabled(state);
